import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

@Component({
  selector: 'legify-ai-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnChanges {
  @Input() name = 'Learn More';

  // this attribute uses for define mat-icon
  @Input() icon = 'start';

  // outlined button or filled button
  @Input() isFilled = true;

  // this prop used to scale up the button with hover
  @Input() isFocusEnabled = true;

  // this attribute uses to hide the icon tag
  @Input() isArrowHide = true;

  // this attribute uses to disable the button
  @Input() isButtonDisabled = false;

  // this attribute uses to only display the icon button
  @Input() isIconOnlyButton = false;

  // this attribute uses to only display the mat-icon
  @Input() isMatIcon = true;

  // this attribute uses to display mat-badge for icon only mode
  @Input() isBadgeDisplay = false;

  // this attribute uses to display value for mat-badge in icon only mode
  @Input() badgeValue: string | number;

  // this attribute uses to set the background color to the button
  @Input() bgColor = '#172640';

  // this attribute uses to set the border color to the button
  @Input() borderColor = '#172640';

  // this attribute uses to set the text color to the button
  @Input() textColor = '#ffffff';

  // this attribute uses to set the icon color to the button
  @Input() iconColor = '#ffffff';

  // this attribute uses to set the custom button width
  @Input() buttonWidth = '';

  // this attribute uses to set the custom button width
  @Input() buttonHeight = '';

  // this attribute uses to reduce or increase the padding size of the icon only button type
  @Input() buttonPadding = '10px';

  /**
   * You can define a CSS class and pass the name of that class to this
   * @param {string} innerClass - CSS class name to further style the button component
   */
  @Input() innerClass = '';

  @Input() fontSize = '16px';

  @Output() Click: EventEmitter<boolean> = new EventEmitter();
  @Output() ButtonEvent: EventEmitter<MouseEvent> = new EventEmitter();

  ngClass = {};
  ngIconClass = {};

  onHandleClick() {
    this.Click.emit(true);
  }

  onClickButtonEvent(event: MouseEvent) {
    this.ButtonEvent.emit(event);
  }

  ngOnChanges() {
    const newClasses = ['la-btn'];
    const newIconClasses = ['la-btn'];
    if (this.isFilled && this.isFocusEnabled) {
      newClasses.push('la-btn__filled');
    }
    if (!this.isFilled && this.isFocusEnabled) {
      newClasses.push('la-btn__outlined');
    }
    if (this.isFilled && !this.isFocusEnabled) {
      newClasses.push('la-btn__filled--not-focus');
    }
    if (!this.isFilled && !this.isFocusEnabled) {
      newClasses.push('la-btn__outlined--not-focus');
    }
    if (this.isButtonDisabled) {
      newClasses.push('la-btn__disabled');
      newIconClasses.push('la-btn__disabled--icon');
    }
    if (!this.isButtonDisabled && this.isIconOnlyButton) {
      newIconClasses.push('la-btn__icon-only');
    }
    if (this.isButtonDisabled && this.isIconOnlyButton) {
      newIconClasses.push('la-btn__disabled--icon-only');
    }
    if (this.isArrowHide) {
      newClasses.push('la-btn__text-only');
    }
    if (this.innerClass) {
      newClasses.push(this.innerClass);
    }
    this.ngClass = newClasses;
    this.ngIconClass = newIconClasses;
  }
}
